import { ActionType } from '../infrastructure/actionTypes';
import { IOrder } from '../infrastructure/interfaces'

export default (list: Array<IOrder> = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_ORDERS_LIST_DONE:
      return [...action.ordersList];
    case ActionType.CREATE_ORDER_DONE:
    {
      list = list.concat(action.order)
      return list;
    }
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderList.ts